import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";

const StyledButton = styled(Button)({
  width: "200px",
  margin: "5px",
  color: "white",
  fontSize: "12px",
  borderRadius: "6px",
  marginTop: "5px",
});

const ViewButton = ({ label, onClick }) => {
  return (
    <StyledButton variant="contained" color="primary" onClick={onClick}>
      {label}
    </StyledButton>
  );
};

export default ViewButton;
